/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.2).
 * The catalog of tool ids a scenario instruction may reference via tool:// — built-in ids plus the
 * account's enabled custom-tool slugs (/api/v1/accounts/:account_id/eva/tool_catalog).
 */
import ApiClient from 'dashboard/api/ApiClient';

// Singular resource read — ApiClient#get already GETs this.url, so no override is needed.
class EvaToolCatalogAPI extends ApiClient {
  constructor() {
    super('eva/tool_catalog', { accountScoped: true });
  }
}

export default new EvaToolCatalogAPI();
